import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import About from "./pages/About";
import Service from "./pages/Service";
import ServiceDetail from "./pages/ServiceDetail";
import Project from "./pages/Project";
import ProjectDetail from "./pages/ProjectDetail";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Team from "./pages/Team";
import TeamDetail from "./pages/TeamDetail";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound"; // 404 page

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={<Home />}
        />

        {/* Giới thiệu */}
        <Route
          path="/gioi-thieu"
          element={<About />}
        />

        {/* Dịch vụ */}
        <Route
          path="/dich-vu"
          element={<Service />}
        />
        <Route
          path="/dich-vu/:slug"
          element={<ServiceDetail />}
        />

        {/* Dự án */}
        <Route
          path="/du-an"
          element={<Project />}
        />
        <Route
          path="/du-an/:slug"
          element={<ProjectDetail />}
        />

        {/* Tin tức / Blog */}
        <Route
          path="/bai-viet"
          element={<Blog />}
        />
        <Route
          path="/bai-viet/:slug"
          element={<BlogDetail />}
        />

        {/* Đội ngũ */}
        <Route
          path="/doi-ngu"
          element={<Team />}
        />
        <Route
          path="/doi-ngu/:slug"
          element={<TeamDetail />}
        />

        {/* FAQ */}
        <Route
          path="/cau-hoi-thuong-gap"
          element={<FAQ />}
        />

        {/* Liên hệ */}
        <Route
          path="/lien-he"
          element={<Contact />}
        />

        {/* 404 */}
        <Route
          path="*"
          element={<NotFound />}
        />
      </Routes>
    </Router>
  );
};

export default App;
